import { Trans, useTranslation } from "react-i18next";
import { RetentionConflict } from "@dashboard-v3/api";
import UsageLink from "./UsageLink";
import { formatDays, getLinkSecurityRoute } from "./helpers";
import { RetentionConflictOrigin } from "./types";

type Props = {
  origin: RetentionConflictOrigin;
  conflict: RetentionConflict;
  savingId?: string;
  retentionDays?: number | null;
};

export default function ConflictUsage({
  origin,
  conflict,
  savingId,
  retentionDays,
}: Props) {
  const { t } = useTranslation("components");
  const days = formatDays(conflict.days, t);

  if (origin === "rule") {
    return (
      <>
        {t("retentionConflictModal.rule.usage", {
          retentionDays: formatDays(retentionDays, t),
        })}
      </>
    );
  }

  const { linkSecurity } = conflict;
  if (!linkSecurity) return null;

  const isSavingThis = linkSecurity.id === savingId;
  const usageKey = isSavingThis
    ? `retentionConflictModal.${origin}.usageThis`
    : `retentionConflictModal.usage.${linkSecurity.type}`;

  return (
    <Trans
      i18nKey={usageKey}
      t={t}
      values={{ name: linkSecurity.name, days }}
      components={{
        item: (
          <UsageLink
            to={getLinkSecurityRoute(linkSecurity)}
            name={linkSecurity.name}
          />
        ),
      }}
    />
  );
}
